export default __webpack_public_path__ + "static/media/smartAutomatization.7b256b93.svg";